import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { TrafficLightLogo } from '@/components/TrafficLightLogo';
import { ArrowLeft, Home } from 'lucide-react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

const NotFound = () => {
  useDocumentTitle('Page Not Found');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[rgb(5,5,5)]">
      {/* Nav — matches login page header */}
      <header className="flex items-center justify-between px-6 py-3 border-b border-zinc-800/60">
        <a href="/" className="flex items-center gap-2">
          <TrafficLightLogo size="sm" showSub />
        </a>
        <nav className="hidden md:flex items-center gap-6 text-sm text-zinc-400">
          <a href="https://aitrafficlight.com/pricing" className="hover:text-white transition-colors">Pricing</a>
          <a href="https://aitrafficlight.com/support" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Support</a>
          <a href="https://aitrafficlight.com/faq" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">FAQ</a>
        </nav>
      </header>

      {/* 404 content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          {/* Large 404 with traffic light accent */}
          <div className="mb-6">
            <span className="text-8xl font-bold tracking-tight bg-gradient-to-b from-red-400 via-yellow-400 to-green-400 bg-clip-text text-transparent select-none">
              404
            </span>
          </div>

          <h1 className="text-2xl font-semibold text-white mb-2">
            Page not found
          </h1>
          <p className="text-zinc-400 mb-8">
            The page <code className="text-zinc-300 bg-zinc-800 px-1.5 py-0.5 rounded text-sm">{location.pathname}</code> doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="w-full sm:w-auto bg-zinc-800 border-zinc-700 hover:bg-zinc-700 text-white"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white"
            >
              <Home className="w-4 h-4 mr-2" />
              Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
